import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CountdownDialogOptions } from './countdown-dialog';


@Component({
    selector: 'app-countdown-dialog',
    styleUrls: ['./countdown-dialog.component.scss'],
    templateUrl: './countdown-dialog.component.html',
})
export class CountdownDialogComponent implements OnInit {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;

    curtime!: number;
    maxtime!: number;
    time!: number | null;
    timerHandle: number | null = null;
    timeStr: string = '';

    constructor(
        public dialogRef: MatDialogRef<CountdownDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CountdownDialogOptions
    ) {
        const self = this;
        self.TitleText = data.TitleText || 'Please wait...';
        self.MessageText = data.MessageText || '';
        self.OKText = data.OKText || 'Stay Logged In';
        self.CancelText = data.CancelText || 'Log Out';
        self.maxtime = data.CountdownTime || 170;
        self.curtime = self.maxtime;
    }

    ngOnInit() {
        const self = this;
        self.time = 100;
        self.timerHandle = null;
        self.timeStr = '';

        // Initialize ticking to get it rolling
        self.Tick();
    }

    CancelHandler() {
        const self = this;
        // Disable timer, if possible
        if (self.timerHandle)
            window.clearTimeout(self.timerHandle);

        self.dialogRef.close(null);
    }

    OKHandler() {
        const self = this;
        // Disable timer, if possible
        if (self.timerHandle)
            window.clearTimeout(self.timerHandle);

        self.dialogRef.close(true);
    }


    private GetTimeString(timeval: number) {
        return Math.floor(timeval / 60) + ':' + ('00' + Math.floor(timeval % 60)).slice(-2);
    }

    private Tick() {
        const self = this;
        self.curtime--;

        if (self.curtime > 0) {
            self.time = Math.floor((self.curtime * 100) / self.maxtime);
            self.timeStr = self.GetTimeString(self.curtime);

            self.timerHandle = window.setTimeout(() => {
                self.Tick();
            }, 1000);
        } else {
            // Close the dialog automatically as a "cancel"
            self.CancelHandler();
        }
    }
}
